<template>
  <div>
    <p class="title md:pb-4 lg:pb-4 pb-2 sm-fsize20 text-center font-bold">
      Sustainable Development Goals
    </p>
    <div
      class="lg:flex md:flex lg:gap-4 md:gap-4 lg:mt-5 md:mt-5 sm-column-reverse"
    >
      <div class="lg:w-1/2 md:w-1/2 w-full z-10 relative lg:pt-0 md:pt-0 pt-5">
        <div class="lg:mt-20 md:mt-16">
          <p class="subtitle fsize18 lh32px sm-fsize14">
            Our initiatives and programs are aligned with the United Nations
            SDGs. Our programs are designed to provide the marginalized sector
            of women with opportunities for financial independence that can
            benefit our economy and communities worldwide. We are building a
            community to support and empower women caregivers in many ways. We
            want to provide these primary caregivers a safe space to be
            themselves and explore their strengths.
          </p>

          <!-- <ul class="flex justify-between fsize14 mt-2">
            <div class="">
              <div class="subtitle sm-fsize14 fontsemibold text-center">
                <div class="w-20 h-20 bg-primary m-auto">
                  <img src="@/assets/images/goals/Goal_5.png" alt="goal1" />
                </div>
                Goal 1 : No Poverty
              </div>
              <div
                class="subtitle sm-fsize14 fontsemibold lg:mt-0 md:mt-0 mt-6 text-center"
              >
                <div class="w-20 h-20 bg-primary m-auto">
                  <img src="@/assets/images/goals/Goal_5.png" alt="goal5" />
                </div>
                Goal 5: Gender Equality
              </div>
              <div
                class="subtitle sm-fsize14 fontsemibold lg:mt-8 mt-6 text-center"
              >
                <div class="w-20 h-20 bg-primary m-auto">
                  <img src="@/assets/images/goals/Goal_11.png" alt="goal1" />
                </div>
                Goal 11: Sustainable Cities &amp; Communities
              </div>
            </div>
            <div>
              <div class="subtitle sm-fsize14 fontsemibold text-center">
                <div class="w-20 h-20 bg-primary m-auto">
                  <img src="@/assets/images/goals/Goal_3.png" alt="goal3" />
                </div>
                Goal 3: Good Health &amp; Well-being
              </div>
              <div class="subtitle sm-fsize14 fontsemibold text-center">
                <div class="w-20 h-20 bg-primary m-auto">
                  <img src="@/assets/images/goals/Goal_8.png" alt="goal8" />
                </div>
                Goal 8: Decent Work &amp; Economic Growth
              </div>

              <div class="subtitle sm-fsize14 fontsemibold text-center">
                <div class="w-20 h-20 bg-primary m-auto">
                  <img src="@/assets/images/goals/Goal_17.png" alt="goal17" />
                </div>
                Goal 17: Partnerships for the Goals
              </div>
            </div>
          </ul> -->
        </div>
        <div class="flex justify-start lg:mt-10 md:mt-8">
          <a href="https://www.un.org/sustainabledevelopment/">
            <b-button variant="primary" class="lg:my-0 md:my-0 my-4"
              >Know More</b-button
            >
          </a>
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 lg:mt-0 md:mt-0 mt-4">
        <a href="https://www.un.org/sustainabledevelopment/">
          <img
            src="@/assets/images/sdd_goals.png"
            alt=""
            class="m-auto lg:w-4/5 md:w-4/5 lg:h-5/6 md:h-5/6 sm-h-240px bg-white object-contain"
          />
        </a>
      </div>
    </div>
    <p
      class="subtitle lg:pt-4 md:pt-4 pt-2 lh32px fsize18 sm-fsize13 sm-lh26 mob-hidden fontsemibold text-center"
    >
      When you donate to address the needs of the family caregivers you support
      Sustainable Development Goals (SDGs) of
    </p>
    <div class="grid lg:grid-cols-6 md:grid-cols-3 grid-cols-3 gap-4 mt-6">
      <div class="fsize18 sm-fsize14 fontsemibold text-center list-none">
        <div class="w-20 h-20 bg-primary m-auto">
          <img src="@/assets/images/goals/Goal_1.png" alt="goal1" />
        </div>
        <div class="mt-3">
          Goal 1: <br />
          No Poverty
        </div>
      </div>
      <div class="fsize18 sm-fsize14 fontsemibold text-center list-none">
        <div class="w-20 h-20 bg-primary m-auto">
          <img src="@/assets/images/goals/Goal_3.png" alt="goal3" />
        </div>
        <div class="mt-3">
          Goal 3:<br />
          Good Health &amp; <br />Well-being
        </div>
      </div>
      <div class="fsize18 sm-fsize14 fontsemibold text-center list-none">
        <div class="w-20 h-20 bg-primary m-auto">
          <img src="@/assets/images/goals/Goal_5.png" alt="goal5" />
        </div>
        <div class="mt-3">
          Goal 5:<br />
          Gender Equality
        </div>
      </div>
      <div class="fsize18 sm-fsize14 fontsemibold text-center list-none">
        <div class="w-20 h-20 bg-primary m-auto">
          <img src="@/assets/images/goals/Goal_8.png" alt="goal8" />
        </div>
        <div class="mt-3">
          Goal 8:<br />
          Decent Work &amp; <br />
          Economic Growth
        </div>
      </div>
      <div class="fsize18 sm-fsize14 fontsemibold text-center list-none">
        <div class="w-20 h-20 bg-primary m-auto">
          <img src="@/assets/images/goals/Goal_11.png" alt="goal11" />
        </div>
        <div class="mt-3">
          Goal 11:<br />
          Sustainable Cities <br />& Communities
        </div>
      </div>
      <div class="fsize18 sm-fsize14 fontsemibold text-center list-none">
        <div class="w-20 h-20 bg-primary m-auto">
          <img src="@/assets/images/goals/Goal_17.png" alt="goal17" />
        </div>
        <div class="mt-3">
          Goal 17:<br />
          Partnerships for <br />the Goals
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
@media (max-width: 640px) {
  .sm-h-240px {
    height: 240px;
  }
  .sm-column-reverse {
    display: flex;
    flex-direction: column-reverse;
  }
}
</style>
